import { IContentImage } from '@casinocore/type-utils';

import { IGameShowHubSectorItem } from './game-show-hub.model';
import { IImmersiveLobbySectorItem } from './immersive-lobby.model';
import { ILiveCasinoLoungeCustomLink } from './live-casino-lounge.model';

export enum ImageType {
    SVG,
    Image,
    Lottie,
}

export enum PromoOptinStatusType {
    Offered = 'OFFERED',
    NotOffered = 'NOT_OFFERED',
    Expired = 'EXPIRED',
    OptedIn = 'OPTED_IN',
    OptedOut = 'OPTED_OUT',
    Invalid = 'INVALID',
    AccountNew = 'ACCOUNT_NEW',
    NotVerified = 'NOT_VERIFIED',
    RGLimitNew = 'RGLIMIT_NEW',
    WithdrowPending = 'WITHDROW_PENDING',
    SelfExcluded = 'SELF_EXCLUDED',
    Risky = 'RISKY',
    Blocked = 'BLOCKED',
    Error = 'ERROR',
}

export interface IContentLink {
    url: any;
    attributes: any;
    title: string;
    text: string;
}

export interface IContentVideo {
    id: string;
    src: string;
    width?: number;
    height?: number;
}

export interface IOption {
    title: string;
    key: string;
    condition: string;
    selected: boolean;
    selectedValue: number;
    defaultValue: number;
}

export const CUSTOM_LINK_TYPE_DRAWER = 'Drawer';
export const CUSTOM_LINK_TYPE_LINK = 'Link';

export class ImmersiveLobbySkeletonLoadingConfiguration {
    logo?: string;
    lottieUrl?: string;
    spinnerType: string;
    backgroundColor?: string;
    loadingText?: string;
    loadingTextColor?: string;
    gameShowLogoUrl?: string;
    ferrisSpinningWheelUrl?: string;
}

export class Dimension {
    width: string;
    height: string;
    y: string;
    x: string;
}

export interface IMobileLandscapeConfiguration {
    minWidth: number;
    maxWidth: number;
    minHeight: number;
    maxHeight: number;
}

export interface ICustomLinkDrawerContent {
    title: string;
    content: string;
    isOnboarding: boolean;
    onboardingCTAText: string;
    image?: IContentImage;
    imageCTA?: IContentLink;
    imageLink?: IContentLink;
    terms: string;
    primaryCTA?: IContentLink;
    condition: string;
    path: string;
}

export interface ICustomLinkModalInfo {
    index: number;
    event: Event;
    panelClass: string;
    isMobilePhone: boolean;
    isStats: boolean;
    modalItem: IGameShowHubSectorItem | ILiveCasinoLoungeCustomLink | IImmersiveLobbySectorItem;
    launchRealtiveUri: string;
    from: string;
}

export class ImmersiveLobbyConfig {
    lobbyType: string;
    loadingConfig: ImmersiveLobbySkeletonLoadingConfiguration;
    onboardingDataPath: string;
    enableSupportForLandscape: boolean;
    mobileLandscapeConfig: IMobileLandscapeConfiguration;
    defaultRenderer: string;
    fallbackRenderer: string;
    fallbackForIpad: boolean;
    idleTimeout: number;
    setMapAdjustedTimeout: number;
    gameLaunchUri: string;
    pauseLottieAnimations: boolean;
}

export class LobbyGameInfo {
    gameId: string;
    gameIconUrl: string;
    icon?: number;
    isLoaded: boolean;
    isDisabled: boolean;
    isGameIconFallback: boolean;
}

export enum LottieAnimationStatus {
    Play,
    Pause,
}

export class ISchedule {
    gameId: string;
    position: string;
    timestamp: Date;
}
export class ICustomLinkDrawer {
    content: Array<ICustomLinkDrawerContent>;
}

export class IPathBasedEnableORDisable {
    disablePaths: Array<string>;
    disableDelay: string;
    enablePaths: Array<string>;
    enableDelay: string;
}
